import React, { Dispatch, useCallback, useState } from "react";
import "./css/index.css";
import { Link } from "react-router-dom";

import ImageInput from "../../components/WriteProject/ImageInput/ImageInput";
import { AllianceInsertInter } from "../../interface/interface";

type Props = {
  type: "fix" | "new";
  InsertData: () => void;
  data: AllianceInsertInter;
  dispatch: Dispatch<{
    type: string;
    payload: string | number;
    index: number | undefined;
  }>;
};

/** 제휴등록 페이지 */
const AllianceInsert = ({
  type,
  InsertData,
  data: { prtn_nm, prtn_use, thumbnail, prtn_info, prtn_desc, link },
  dispatch,
}: Props) => {
  /** 에러 판단 상태 */
  const [isError, setIsError] = useState(false);

  /** 조건 체크 함수 */
  const CheckData = useCallback(() => {
    if (prtn_nm && prtn_use && thumbnail && prtn_info && prtn_desc && link) {
      InsertData();
    } else {
      setIsError(true);
    }
  }, [prtn_nm, prtn_use, thumbnail, prtn_info, prtn_desc, link]);

  /** 상태 업데이트 함수 */
  const UpdateReducer = useCallback(
    (type: string, value: string | number) => {
      dispatch({
        type: `dispatch/${type}`,
        payload: value,
        index: undefined,
      });
    },
    [dispatch]
  );

  return (
    <main className="alliance-insert-page">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <Link to="/etc/alliance" className="left">
              <img src="/assets/common/rightarrow.svg"></img>
            </Link>
            <p>제휴 등록</p>
          </div>
        </div>
        <div className="alliance-content-wrapper">
          <div className="alliance-content-left">
            <div className="input-wrapper">
              <div className="title-wrapper">
                <div className="title">제휴사</div>
                {isError && !prtn_nm ? (
                  <div className="error-msg">제휴사명을 입력해주세요</div>
                ) : undefined}
              </div>
              <div
                className={`input-box ${
                  isError && !prtn_nm ? "alliance-error" : ""
                }`}
              >
                <input
                  className="input-comp"
                  placeholder="제휴사명을 입력해주세요"
                  value={prtn_nm}
                  onChange={(e) => {
                    UpdateReducer("prtn_nm", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="input-wrapper second-input">
              <div className="title-wrapper">
                <div className="title">제휴 내용</div>
                {isError && !prtn_desc ? (
                  <div className="error-msg">제휴 내용을 입력해주세요</div>
                ) : undefined}
              </div>
              <div
                className={`input-box ${
                  isError && !prtn_desc ? "alliance-error" : ""
                }`}
              >
                <input
                  className="input-comp"
                  placeholder="제휴 내용을 입력해주세요"
                  value={prtn_desc}
                  onChange={(e) => {
                    UpdateReducer("prtn_desc", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="input-wrapper second-input">
              <div className="title-wrapper">
                <div className="title">제휴사 홈페이지</div>
                {isError && !link ? (
                  <div className="error-msg">url을 입력해주세요</div>
                ) : undefined}
              </div>
              <div
                className={`input-box ${
                  isError && !link ? "alliance-error" : ""
                }`}
              >
                <input
                  className="input-comp"
                  placeholder="url을 입력해주세요"
                  value={link}
                  onChange={(e) => {
                    UpdateReducer("link", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="textarea-wrapper">
              <div className="title-wrapper">
                <div className="title">기업 소개</div>
                {isError && !prtn_info ? (
                  <div className="error-msg">기업 소개를 입력해주세요</div>
                ) : undefined}
              </div>
              <div
                className={`textarea-box ${
                  isError && !prtn_info ? "alliance-error" : ""
                }`}
              >
                <textarea
                  placeholder="기업 소개를 입력해주세요"
                  value={prtn_info}
                  onChange={(e) => {
                    UpdateReducer("prtn_info", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="textarea-wrapper">
              <div className="title-wrapper">
                <div className="title">이용법</div>
                {isError && !prtn_use ? (
                  <div className="error-msg">이용법을 입력해주세요</div>
                ) : undefined}
              </div>
              <div
                className={`textarea-box ${
                  isError && !prtn_use ? "alliance-error" : ""
                }`}
              >
                <textarea
                  placeholder="이용법을 입력해주세요"
                  value={prtn_use}
                  onChange={(e) => {
                    UpdateReducer("prtn_use", e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="alliance-content-right">
            <ImageInput
              title="썸네일 이미지"
              sub={`112x112px 권장 / 20mb 이내
jpg / png 확장자`}
              data={thumbnail}
              __update={UpdateReducer}
              isError={isError}
              type="img"
            />
            <button className="alliance-insert-btn" onClick={CheckData}>
              {type === "new" ? "등록" : "저장"}하기
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AllianceInsert;
